// Job owner detail  ******************************************************************************
// pathname: /v1/job-operation/{jobSlug}/owner-detail
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';

interface JobOwnerDetailProps {
  jobSlug: string;
  shouldFetch?: boolean;
  locale?: string;
  serverSideData?: ApiSchema<'OwnerJobRead'>;
}

/**
 * @description SWR: fetch job detail for owner.
 *
 * * **jobSlug**: string. The job slug.
 * * **shouldFetch**: boolean. Whether to start fetch job owner details (eg: fetch only for logged-in users). Default true.
 * * **locale**: string. The locale to use for the request. Default: 'ro'.
 * * **serverSideData**: <ApiSchema<'OwnerJobRead'>>. It holds the data retrieved from the server-side request. Optional.
 */

export const useSwrJobOwnerDetail = (
  props: JobOwnerDetailProps,
) => {
  // Destructure props
  const {
    jobSlug,
    shouldFetch = true,
    locale = 'ro',
    serverSideData,
  } = props;

  // SWR: fetch data
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<
  ApiSchema<'OwnerJobRead'>
  >({
    url: `/v1/job-operation/${jobSlug}/owner-detail`,
    shouldFetch,
    locale,
    serverSideData,
    apiOptions: {
      dedupingInterval: 1000 * 60, // 1 minute
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
